<template>
  <div class="line-items-table-header d-none d-sm-flex px-i">
    <div class="line-items-tabe-header-item col-8">
      Description
    </div>
    <div class="line-items-tabe-header-item col-3">
      Quantity
    </div>
    <div class="line-items-tabe-header-item col-4">
      Tax
    </div>
    <div class="line-items-tabe-header-item col-4">
      Price
    </div>
    <div class="line-items-tabe-header-item col-5">
      Amount
    </div>
  </div>
</template>

<script>
export default {

};
</script>
